import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from '@mui/icons-material/Close';
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ShareIcon from "@mui/icons-material/Share";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Alert, Divider, List, ListItem, ListItemText, Modal, Tooltip, useMediaQuery } from "@mui/material";
import Logo1 from "../assets/no.webp";
import moment from "moment";

import {
  WhatsappShareButton,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share";
import "../App.css";
import cartPlusIcon from "../assets/cart-plus 1.svg";
import cartMinusIcon from "../assets/cart-minus.svg";
import { IconButton } from "@mui/material";
import "jspdf-autotable";
import TablePagination from "@mui/material/TablePagination";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import { useDispatch, useSelector } from "react-redux";
import { cartReducer } from "../redux/features/listSlice";
import { Bounce, toast } from "react-toastify";
import Loader from "./Loader";
import PackageInclusionModel from "./PackageInclusionModel";
import axios from "axios";
import { GET_PACKAGE_INCLUSION, GET_REPORT_NEW, NEW_IT_DOSE_REPORT_API } from "../Endpoints/endpoint";

const style = {
  position: 'absolute',
  top: '30%',
  left: '50%',
  transform: 'translate(-30%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  boxShadow: 24,
  p: 4,
  borderRadius: "30px"
};
// STYLED DESIGN FOR TABLE CELL TO SEE COLORFULL
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#FFF4F4",
    color: "black",
    padding: '12px 16px',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: '14px',
    padding: '12px 16px',
  },
}));

// STYLED DESIGN FOR TABLE ROW TO SEE COLORFULL
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#FFFFFF",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#F4F7FC",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const ListingData = (props) => {
  document.title = "Apollo Diagnostics"
  const filtervalue = props.filter;
  const messageError = props.errorMessage;
  const dispatch = useDispatch()
  const { cartItemList } = useSelector((s) => s.edos)
  const [filterdData, setFilteredData] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [show, setShow] = React.useState(false);
  const [loaders, setLoaders] = React.useState(false)
  const [shareData, setShareData] = React.useState([]);
  const [expandedRows, setExpandedRows] = React.useState([]);
  const [expandState, setExpandState] = React.useState({});
  const [inputValue, setInputValue] = React.useState("");
  const [query, setQuery] = React.useState("");
  const [showTable, setShowTable] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [selectedData, setSelectedData] = React.useState(null)
  const [showInclusion, setSHowInclusion] = React.useState(false)
  const [inclusionList, setInclusionList] = React.useState([])
  const [cartValueItem, setCartValueItem] = React.useState([]) // props.cartItemList
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCloseInclusion = () => setSHowInclusion(false);
  const handleShowInclusion = () => setSHowInclusion(true);

  React.useEffect(() => {
    setCartValueItem(cartItemList)
  }, [cartItemList])


  React.useEffect(() => {
    if (cartValueItem.length > 0) {
      sessionStorage.setItem("cartValues", JSON.stringify(cartValueItem))
      dispatch(cartReducer(cartValueItem))
    } else {
      sessionStorage.setItem("cartValues", JSON.stringify([]))
      dispatch(cartReducer([]))
    }
  }, [cartValueItem])

  // LIST-API CALLING
  React.useEffect(() => {
    if (filtervalue?.length === 0) {
      setFilteredData([]);
      setData([]);
      setShowTable(false);
      setQuery("");
      setInputValue("");
    } else {
      // Create a Set to store unique ids
      const uniqueIds = new Set();

      // Filter data based on unique id and non-zero price
      const filteredData = filtervalue?.filter(item => {
        // Check if the id is unique and the price is not zero
        const isUnique = !uniqueIds.has(item.test_code) && item.mrp !== 0;

        // If unique, add the id to the Set
        if (isUnique) {
          uniqueIds.add(item.test_code);
        }

        return isUnique;
      });

      setFilteredData(filteredData);
      setShowTable(true);
      setData(filteredData);
      setQuery("");
      setInputValue("");
      setSelectedData(null)
    }
  }, [filtervalue]);

  const handleSearch = (e, value) => {
    if (value) {
      const text = value?.test_name
      const result = text.toLowerCase();
      setQuery(result);
      setPage(0);
    } else {
      setQuery("");
      setPage(0);
      setSelectedData([])
      setInputValue("")
    }
  };

  const handleEpandRow = (event, userId) => {
    const currentExpandedRows = expandedRows;
    const isRowExpanded = currentExpandedRows.includes(userId);

    let obj = {};
    isRowExpanded ? (obj[userId] = false) : (obj[userId] = true);
    setExpandState(obj);

    if (obj[userId] === true) {
      setExpandedRows([userId]);
    } else {
      setExpandedRows([0]);
    }
  };

  //  ADD TO CART ITEM HANDLER-------

  const addToCartHandler = (value) => {
    const filteredData = cartValueItem.filter((res) => res.id == value.id);

    if (filteredData.length > 0) {
    } else {
      setCartValueItem([...cartValueItem, value])
    }
  }

  //  REMOVE FROM CART HANDLER-----------
  const removeSelecteHandler = (value) => {
    const removeMatchItem = cartValueItem.filter((obj) => obj.id !== value)
    setCartValueItem(cartValueItem.filter((obj) => obj.id !== value.id))
    sessionStorage.setItem("cartValues", JSON.stringify(removeMatchItem))
    dispatch(cartReducer(removeMatchItem))
  }

  // HANDLER TO CHECK SELECTED TESTS--------
  const checkAddedValue = (value) => {
    const filteredData = cartValueItem.filter((res) => res.id == value.id);
    if (filteredData?.length > 0) {
      return true
    } else {
      return false
    }
  }

  // TABLE COLOR MATCHING HANDLER--------
  const csshandler = (num) => {
    if (num % 2 !== 0) {
      return "#FFFFFF"  // Odd rows are white
    } else {
      return "#F4F7FC"  // Even rows are #F4F7FC
    }
  }

  // SHARING BUTTON...
  const handleShare = (e, userId) => {
    const value = filterdData.filter((id) => id.id === userId);
    setShareData(value);
    handleShow();
  };

  // HANDLE REPORT 
  // const handleReport = (e, test_code) => {
  //   let formData = new FormData();
  //   formData.append("UserName", "FeedbackAPI");
  //   formData.append("Password", "PE07-BA10-AP30-SH20-J271");
  //   formData.append("TestCode", test_code);
  //   setLoaders(true);

  //   fetch("https://report.apollodiagnostics.in/Apollo/design/onlinelab/DummyReportAPI.aspx", {
  //     method: 'POST',
  //     body: formData,
  //   })
  //     .then(function (data) {
  //       setLoaders(false);
  //       if (data.url) {
  //         window.open(data.url);
  //       }
  //     })
  //     .catch(function (error) {
  //       setLoaders(false);
  //       console.log("Error fetching report:", error);
  //       // toast.error("Failed to fetch report");
  //     });
  // };
  const handleReport = (e, test_code) => {
    // console.log("test_code", test_code)
    let payload = {
      "testCode":test_code
  }
  // console.log("payload", payload)
  axios.post(process.env.REACT_APP_API_PATH  + GET_REPORT_NEW, payload)
  .then((res) => {
    // console.log("res", res)
    const { url, itdose } = res.data;
    
    // Check if itdose is 1, then call newitDoseAPICall
    if (itdose === 1) {
      newitDoseAPICall(test_code);
    } else {
      // Existing functionality - Check if URL exists and is not empty
      if (url && url.trim() !== "") {
        // Open the URL in a new tab
        window.open(url, '_blank');
      } else {
        // Show toast error if URL is null or empty
        toast.error("Report is not available");
      }
    }
  })
  .catch((err) => {
    console.log("err", err)
    toast.error("Failed to fetch report");
  })
  }

  const newitDoseAPICall = (testCode) => {
    // console.log('new it dose api called', testCode)
    setLoaders(true)
    
    // Create FormData as per the curl command
    let formData = new FormData();
    formData.append("TestCode", testCode);
    
    // Make the API call using axios with FormData
    axios.post(NEW_IT_DOSE_REPORT_API, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Cookie': 'ASP.NET_SessionId=bdfzkhqfavok0a0zqr0g2zsn'
      },
      responseType: 'blob' // Important for handling PDF response
    })
    .then((response) => {
      setLoaders(false)
      // console.log("New IT Dose API response:", response);
      
      // Create a blob from the response data
      const blob = new Blob([response.data], { type: 'application/pdf' });
      
      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);
      
      // Open the PDF in a new tab
      window.open(url, '_blank');
      
      // Clean up the URL object after a short delay to free memory
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 1000);
    })
    .catch((error) => {
      setLoaders(false)
      // console.log("Error fetching report from new IT Dose API:", error);
      toast.error("Failed to fetch report from new IT Dose API");
    });
  }




  // const handleReport=(e,test_code)=>{
  //   // console.log("test_codetest_code",test_code)
  //   let formData = new FormData();
  //     // formData.append("UserName","FeedbackAPI");
  //     // formData.append("Password", "PE07-BA10-AP30-SH20-J271");
  //     formData.append("UserName","FeedbackAPI");
  //     formData.append("Password", "PE07-BA10-AP30-SH20-J271");
  //     formData.append("TestCode", test_code);
  //     // https://report.apollodiagnostics.in/Apollo/design/onlinelab/DummyReportAPI.aspx
  //     // https://lims.apollodiagnostics.in/Apollo/Design/Investigation/DummyReportView.aspx
  //     setLoaders(true)
  //     fetch("https://report.apollodiagnostics.in/Apollo/design/onlinelab/DummyReportAPI.aspx", {
  //       method: 'POST',
  //    body: formData,
  //   }).then(function (resp) {
  //     console.log("reeeee report msg",resp)
  //     console.log("reeeee report url",resp.url)
  //       return resp.blob();
  //   }).then(function (blob) {
  //     console.log("reeeee report blob",blob)
  //       setLoaders(false)
  //       var len = blob.size;
  //       if (len < 200) {
  //           const dd = dateText(blob)
  //           toast.warning(dd)
  //       } else {
  //           const blobUrl = URL.createObjectURL(blob);
  //           window.open(blobUrl);
  //       }

  //   })
  // }
  // const dateText = async (blob) => {
  //   const dd = await blob.text()
  //   toast.warning(dd)
  // }

  // HANDLE SHOW PACKAGE INCLUSION
  const packageInclusionMethod = (test_code) => {
    // console.log("test_codetest_codetest_code",test_code)
    packageIncluAPi(test_code)
  }

  const packageIncluAPi = async (code) => {
    const dataJson = {
      // "testCode":"PR336"
      "testCode": code
    }
    setLoaders(true)
    await axios.post(process.env.REACT_APP_API_PATH + GET_PACKAGE_INCLUSION, dataJson)
      .then((res) => {
        setLoaders(false)
        if (res.data.status) {
          // console.log("res inclusion",res.data.data)
          setInclusionList(res.data.data)
          handleShowInclusion(true)
        } else {
          setInclusionList([])
          toast.warn("Inclusions Not Available", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce
          })
        }
      })
      .catch((err) => {
        setLoaders(false)
        console.log("err", err)
        setInclusionList([])
      })
  }

  const OthershareUrl = shareData.map((data) => [
    // console.log("data", data),
    `
  Test Code : ${data.test_code || "N/A"}
  Test Name : ${data.test_name || "N/A"}
  Sample type : ${data.sampleType_name || "N/A"}
  Disease Name : ${data.disease_name || "N/A"}
  MRP : ₹ ${data.mrp || "N/A"}
  Methodology : ${data.methodology || "N/A"}
  TAT : ${data.tat || "N/A"}
    `,
  ]);

  const filterOptions = createFilterOptions({
    matchFrom: 'start middle',
    stringify: (option) => option.test_name,
  });

  if (messageError && filtervalue.length === 0) {
    return (
      <>
        <Card
          sx={{
            minWidth: 275,
            background: "white",
            textAlign: "center",
            marginBottom: "10px",
            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px'
          }}
        >

          <CardContent>
            {/* <Typography variant="h4">Welcome to Apollo Diagnostics</Typography> */}
            <Typography variant="h6" sx={{ fontSize: '14px', fontWeight: 'normal', lineHeight: 'normal' }}>
              Search for tests using the search bar below
            </Typography>

          </CardContent>
          <CardActions sx={{ justifyContent: "center" }}>
            <Stack spacing={2} sx={{ width: 490 }}>
              <Autocomplete
                value={selectedData}
                inputValue={inputValue}
                // clearOnBlur={true}
                getOptionLabel={(filterdData) =>
                  `${filterdData.test_name}`
                }
                options={data}
                filterOptions={filterOptions}
                isOptionEqualToValue={(option, value) =>
                  option.id === value.id
                }
                noOptionsText={"No Data Available"}

                onChange={(params, value) => {
                  handleSearch(params, value)
                  setSelectedData(value)
                }}
                renderOption={(props, filterdData) => (
                  <Box component="li" {...props} sx={{ fontSize: "14px" }} key={filterdData.id}>
                    {filterdData.test_name}
                  </Box>
                )}
                onInputChange={(event, newInputValue) => {
                  if (event) {
                    setInputValue(newInputValue);
                    setQuery(newInputValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search with Test Name or Code"
                    value={params}
                    size="small"
                  />
                )}
              />
            </Stack>
          </CardActions>
          {/* Alert message */}

          <Stack sx={{ width: '100%', marginTop: '10px', marginBottom: '10px', pl: 6, pr: 6 }} spacing={2}>
            {/* <Alert severity="warning">The mentioned TAT refers to the processing time from sample receipt at the testing laboratory to result reporting. Kindly ensure to factor in the logistics TAT for samples transported from other cities.</Alert> */}
            <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>Note:  The mentioned TAT refers to the processing time from sample receipt at the testing laboratory to result reporting. Kindly ensure to factor in the logistics TAT for samples transported from other cities.</Typography>
          </Stack>
        </Card>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img src={Logo1} alt="img" style={{ height: "350px" }} />
        </div>
      </>
    );
  } else {
    return (
      <div>
        {loaders && <Loader />}
        <Card
          sx={{
            minWidth: 275,
            background: "white",
            textAlign: "center",
            marginBottom: "10px",
            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px'
          }}
        >
          <CardContent>
            {/* <Typography variant="h4">Welcome to Apollo Diagnosticskkkkkkkkkk</Typography> */}
            <Typography variant="h6" sx={{ fontSize: '14px', fontWeight: 'normal', lineHeight: 'normal' }}>
              Search for tests using the search bar below
            </Typography>
          </CardContent>
          <CardActions sx={{ justifyContent: "center" }}>
            <Stack spacing={2} sx={{ width: 660 }}>
              <Autocomplete
                value={selectedData}
                inputValue={inputValue}

                getOptionLabel={(filterdData) =>
                  `${filterdData.test_name}- ${filterdData.test_code}`
                }
                options={data}
                // filterOptions={filterOptions}
                isOptionEqualToValue={(option, value) =>
                  option.id === value.id
                }
                noOptionsText={"No Data Available"}
                onChange={(params, value) => {
                  handleSearch(params, value)
                  setSelectedData(value)
                }}
                renderOption={(props, filterdData) => (
                  <Box component="li" {...props} sx={{ fontSize: "14px" }} key={filterdData.id}>
                    {filterdData.test_name}
                  </Box>
                )}
                onInputChange={(event, newInputValue) => {
                  if (event) {
                    setInputValue(newInputValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search with Test Name or Code"
                    value={params}
                    size="small"
                  />
                )}
              />
            </Stack>
          </CardActions>
          {/* Alert message */}

          <Stack sx={{ width: '100%', marginTop: '10px', marginBottom: '10px', pl: 6, pr: 6 }} spacing={2}>
            {/* <Alert severity="warning">The mentioned TAT refers to the processing time from sample receipt at the testing laboratory to result reporting. Kindly ensure to factor in the logistics TAT for samples transported from other cities.</Alert> */}
            <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>Note:  The mentioned TAT refers to the processing time from sample receipt at the testing laboratory to result reporting. Kindly ensure to factor in the logistics TAT for samples transported from other cities.</Typography>
          </Stack>
        </Card>

        {/* Alert message */}

        {/* <Stack sx={{ width: '100%', marginTop: '10px', marginBottom: '10px', }} spacing={2}>
          <Alert severity="warning">The mentioned TAT refers to the processing time from sample receipt at the testing laboratory to result reporting. Kindly ensure to factor in the logistics TAT for samples transported from other cities.</Alert>
        </Stack> */}

        {(query.length !== 0
          ? query
          : showTable && showTable === true
            ? showTable
            : query) && (() => {
              const filteredResults = filterdData.filter(
                (user) =>
                  user.test_name.toLowerCase().includes(query) ||
                  user.test_code.toLowerCase().includes(query)
              );
              
              return (
                <Box>
              <TableContainer component={Paper} sx={{ backgroundColor: '#F4F7FC' }}>
                <Table sx={{ minWidth: 750, backgroundColor: '#F4F7FC' }} aria-label="caption table">
                  <TableHead >
                    <StyledTableRow>
                      <StyledTableCell sx={{ fontWeight: "bold" }} ><Box sx={{ width: "max-content", fontWeight: "bold" }}>Test Code</Box></StyledTableCell>
                      <StyledTableCell sx={{ fontWeight: "bold" }}>Test Name</StyledTableCell>
                      {/* <StyledTableCell sx={{ fontWeight: "bold" }}>PackageId</StyledTableCell> */}
                      {/* <StyledTableCell sx={{ fontWeight: "bold" }}><Box sx={{ width: "max-content", fontWeight: "bold" }}>Package Name</Box></StyledTableCell> */}
                      <StyledTableCell sx={{ fontWeight: "bold" }}>MRP</StyledTableCell>
                      <StyledTableCell sx={{ fontWeight: "bold" }}>Methodology</StyledTableCell>
                      <StyledTableCell sx={{ fontWeight: "bold" }}>TAT</StyledTableCell>
                      <StyledTableCell sx={{ fontWeight: "bold" }}>Logistics TAT</StyledTableCell>
                      <StyledTableCell sx={{ fontWeight: "bold", position: 'sticky', right: 0, textAlign: 'center' }}>Actions</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>

                  <TableBody sx={{ backgroundColor: '#F4F7FC' }}>
                    {filteredResults
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)

                      .map((user, index) => {
                        return (
                          <React.Fragment key={index}>
                            <StyledTableRow colSpan={6}>
                              <StyledTableCell sx={{ cursor: "pointer", color: "#2fcc2f", fontSize: "14px", fontWeight: "bold" }} onClick={() => packageInclusionMethod(user?.test_code)}>{user?.test_code || ""}</StyledTableCell>
                              <StyledTableCell>{user?.test_name || ""}</StyledTableCell>
                              {/* <StyledTableCell>{user?.package_id || ""}</StyledTableCell> */}
                              {/* <StyledTableCell>{user?.packagename || ""}</StyledTableCell> */}
                              <StyledTableCell><Box sx={{ display: "flex" }}><Box sx={{ marginRight: "1.5px" }}>₹ </Box><Box>{user?.mrp || ""}</Box> </Box></StyledTableCell>
                              <StyledTableCell>{user?.methodology || ""}</StyledTableCell>
                              <StyledTableCell><Box sx={{ width: "max-content" }}>{user?.tat || ""}</Box></StyledTableCell>
                              <StyledTableCell><Box sx={{ width: "max-content" }}>
                                {user?.LogisticTat && user.LogisticTat !== "N/A" 
                                  ? (() => {
                                      const duration = moment.duration(user.LogisticTat);
                                      const days = duration.asDays();
                                      const hours = duration.asHours();
                                      
                                      if (days >= 1) {
                                        const roundedDays = Math.round(days);
                                        return `${roundedDays} Day${roundedDays !== 1 ? 's' : ''}`;
                                      } else {
                                        const roundedHours = Math.round(hours);
                                        return `${roundedHours} Hr${roundedHours !== 1 ? 's' : ''}`;
                                      }
                                    })()
                                  : "N/A"
                                }
                              </Box></StyledTableCell>

                              <StyledTableCell style={{ position: 'sticky', background: csshandler(index + 1), right: 0 }}>
                                <Box style={{ display: "flex" }}>
                                  <Tooltip
                                    title={"Share"}
                                    placement="bottom-start"
                                  >
                                    <IconButton
                                      value={`Test code : ${user.test_code}, Test Name: ${user.test_name}`}
                                      onClick={(e) => handleShare(e, user.id)}
                                      sx={{ fontSize: '20px', padding: '8px' }}
                                    >
                                      <ShareIcon style={{ color: "#007c9d", fontSize: '20px' }} />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip
                                    title={expandState[user.id] ? "Close Details" : "View Details"}
                                    placement="bottom-start"
                                  >
                                    <IconButton
                                      aria-label="visible"
                                      onClick={(event) =>
                                        handleEpandRow(event, user.id)
                                      }
                                      color="primary"
                                      sx={{ fontSize: '20px', padding: '8px' }}
                                    >
                                      {expandState[user.id] ? (
                                        <VisibilityOffIcon sx={{ color: "#7D5C04", fontSize: '20px' }} />
                                      ) : (
                                        <VisibilityIcon sx={{ color: "#FBBA00", fontSize: '20px' }} />
                                      )}
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip
                                    title={"Sample Report"}
                                    placement="bottom-start"
                                  >
                                    <IconButton
                                      // value={`Test code : ${user.test_code}, Test Name: ${user.test_name}`}
                                      onClick={(e) => handleReport(e, user?.test_code)}
                                      sx={{ fontSize: '20px', padding: '8px' }}
                                    >
                                      <PictureAsPdfIcon style={{ color: "#AC285B", fontSize: '20px' }} />
                                    </IconButton>
                                  </Tooltip>
                                  {checkAddedValue(user) ? (
                                    <Tooltip
                                      title={"Remove from cart"}
                                      placement="bottom-start"
                                    >
                                      <IconButton 
                                        onClick={() => removeSelecteHandler(user)}
                                        sx={{ fontSize: '20px', padding: '8px' }}
                                      >
                                        <img
                                          src={cartMinusIcon}
                                          alt="cartMinusIcon"
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                            filter: "invert(12%) sepia(74%) saturate(5918%) hue-rotate(358deg) brightness(91%) contrast(97%)"
                                          }}
                                        />
                                        {/* <img src={cartMinusIcon} alt="cartMinusIcon" style={{width:"25px", color:"#CB0505"}} /> */}
                                        {/* <RemoveIcon sx={{color:'red'}}/> */}
                                      </IconButton>
                                    </Tooltip>
                                  ) : (
                                    <Tooltip
                                      title={"Add to cart"}
                                      placement="bottom-start"
                                    >
                                      <IconButton 
                                        onClick={() => addToCartHandler(user)}
                                        sx={{ fontSize: '20px', padding: '8px' }}
                                      >
                                        <img
                                          src={cartPlusIcon}
                                          alt="cartMinusIcon"
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                            filter: "invert(24%) sepia(97%) saturate(1994%) hue-rotate(127deg) brightness(97%) contrast(103%)"
                                          }}
                                        />
                                        {/* <img src={cartPlusIcon} alt="cartMinusIcon" style={{width:"25px",color:"#007A00"}} /> */}
                                        {/* <AddIcon/> */}
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </Box>

                              </StyledTableCell>
                            </StyledTableRow>
                            {expandedRows.includes(user.id) ? (
                              <>
                                {isSmallScreen ? (
                                  <tr>
                                    <td colSpan="6" style={{ padding: 0 }}>
                                      <List className="custom-list">
                                        <ListItem sx={{ display: 'flex' }}>
                                          <ListItemText
                                            primary="Lab Name:"
                                            secondary={user?.centre_name || "N/A"}
                                            sx={{ fontSize: '14px' }}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="Category:"
                                            secondary={user?.category || "N/A"}
                                            sx={{ fontSize: '14px' }}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="Specimen Remarks:"
                                            secondary={user?.specimen_remarks || "N/A"}
                                            sx={{ fontSize: '14px' }}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="Sample Type:"
                                            secondary={user?.sampleType_name || "N/A"}
                                            sx={{ fontSize: '14px' }}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="Frequency:"
                                            secondary={user?.frequency || "N/A"}
                                            sx={{ fontSize: '14px' }}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="TAT:"
                                            secondary={user?.tat || "N/A"}
                                            sx={{ fontSize: '14px' }}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="Temperature:"
                                            secondary={user?.temp || "N/A"}
                                            sx={{ fontSize: '14px' }}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="Container:"
                                            secondary={user?.container || "N/A"}
                                            sx={{ fontSize: '14px' }}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="Cut off:"
                                            secondary={user?.cut_off || "N/A"}
                                            sx={{ fontSize: '14px' }}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="Methodology:"
                                            secondary={user?.methodology || "N/A"}
                                            sx={{ fontSize: '14px' }}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="Disease:"
                                            secondary={user?.disease_name || "N/A"}
                                            sx={{ fontSize: '14px' }}
                                          />
                                        </ListItem>
                                      </List>
                                    </td>
                                  </tr>
                                ) : (
                                  <tr>
                                    <td colSpan="6" style={{ padding: 0 }}>
                                      <List className="custom-list">
                                        <ListItem sx={{ display: 'flex', gap: 2 }}>
                                          <ListItemText
                                            primary="Tagged Lab Name:"
                                            secondary={user?.centre_name || "N/A"}
                                            sx={{ flex: 1, fontSize: '14px' }}
                                          />
                                          <ListItemText
                                            primary="Processing Lab:"
                                            secondary={user?.processing_lab || "N/A"}
                                            sx={{ flex: 1, fontSize: '14px' }}
                                          />
                                          <ListItemText
                                            primary="Category:"
                                            secondary={user?.category || "N/A"}
                                            sx={{ flex: 1, fontSize: '14px' }}
                                          />
                                          <ListItemText
                                            primary="Specimen Remarks:"
                                            secondary={user?.specimen_remarks || "N/A"}
                                            sx={{ flex: 1, fontSize: '14px' }}
                                          />
                                        </ListItem>
                                        <ListItem sx={{ display: 'flex', gap: 2 }}>
                                          <ListItemText
                                            primary="TAT:"
                                            secondary={user?.tat || "N/A"}
                                            sx={{ flex: 1, fontSize: '14px' }}
                                          />
                                          <ListItemText
                                            primary="Temperature:"
                                            secondary={user?.temp || "N/A"}
                                            sx={{ flex: 1, fontSize: '14px' }}
                                          />
                                          <ListItemText
                                            primary="Container:"
                                            secondary={user?.container || "N/A"}
                                            sx={{ flex: 1, fontSize: '14px' }}
                                          />
                                          <ListItemText
                                            primary="Cut off:"
                                            secondary={user?.cut_off || "N/A"}
                                            sx={{ flex: 1, fontSize: '14px' }}
                                          />
                                        </ListItem>
                                        <ListItem sx={{ display: 'flex', gap: 2 }}>
                                          <ListItemText
                                            primary="Methodology:"
                                            secondary={user?.methodology || "N/A"}
                                            sx={{ flex: 1, fontSize: '14px' }}
                                          />
                                          <ListItemText
                                            primary="Disease:"
                                            secondary={user?.disease_name || "N/A"}
                                            sx={{ flex: 1, fontSize: '14px' }}
                                          />
                                          <ListItemText
                                            primary="Sample Type:"
                                            secondary={user?.sampleType_name || "N/A"}
                                            sx={{ flex: 1, fontSize: '14px' }}
                                          />
                                          <ListItemText
                                            primary="Frequency:"
                                            secondary={user?.frequency || "N/A"}
                                            sx={{ flex: 1, fontSize: '14px' }}
                                          />
                                        </ListItem>
                                        <ListItem sx={{ display: 'flex', gap: 2 }}>
                                          <ListItemText
                                            // primary="Frequency:"
                                            // secondary={user?.frequency || "N/A"}
                                            sx={{ flex: 1 }}
                                          />
                                        </ListItem>
                                      </List>
                                    </td>
                                  </tr>

                                )}
                              </>

                            ) : null}
                          </React.Fragment>
                        )
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={filteredResults.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
                </Box>
              );
            })()}

        {/* Inclusion Model */}
        <PackageInclusionModel showInclusion={showInclusion} handleCloseInclusion={handleCloseInclusion} data={inclusionList} />
        {/* sharing data model */}
        <Modal open={show} onClick={handleClose} >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ display: "flex", justifyContent: "space-between", fontSize: '14px' }}>
              Share Data
              <IconButton onClick={() => handleClose()} color="error"><CloseIcon /></IconButton>
            </Typography>
            <Divider />

            <Typography id="modal-modal-description" sx={{ mt: 2, textAlign: "center" }}>
              <WhatsappShareButton
                url={OthershareUrl}
                style={{ marginRight: "9px" }}
              >
                <WhatsappIcon size={40} round={true} />
              </WhatsappShareButton>

              <EmailShareButton url={OthershareUrl}>
                <EmailIcon size={40} round={true} />
              </EmailShareButton>

            </Typography>
          </Box>
        </Modal>

      </div>
    );
  }
};

export default ListingData;

